import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Hubs() {
  const [hubs, setHubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHubs = async () => {
      try {
        const response = await fetch('/api/users/hubs', {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        console.log('Fetched hubs:', data);
        setHubs(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Fetch error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchHubs();
  }, []);

  if (loading) return <div className="text-center py-8">Loading hubs...</div>;
  if (error) return <div className="text-center py-8 text-red-600">Error: {error}</div>;
  if (!hubs.length) return <div className="text-center py-8">No hubs found</div>;

  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Hubs</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {hubs.map(hub => (
          <Link key={hub._id} to={`/hub/${hub.slug}`} className="block bg-white rounded-lg shadow-md p-4 hover:shadow-lg transition">
            <h2 className="font-semibold text-lg">{hub.name || hub.hubName || 'Hub'}</h2>
            <p className="text-gray-600">{hub.tagline || hub.description || 'Local hub'}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
